export const useOverflowHidden = () => {
  const isOverflowHidden = ref(false);

  const setOverflowHidden = (value: boolean) => {
    isOverflowHidden.value = value;
    if (value) {
      document.body.style.overflowY = 'hidden';
      document.body.classList.add('no-scroll');
    } else {
      document.body.style.overflowY = 'auto';
      document.body.classList.remove('no-scroll');
    }
  };

  return { isOverflowHidden, setOverflowHidden };
};
